import { DataAnalysisRequestModel } from './dataAnalysisRequest.model';

export class DataAnalysisExportModel {
    models: DataAnalysisRequestModel[];
}
